/**
 * What the agent tools may reach beyond the store: the live 3D and plan surfaces (pictures,
 * camera moves) and project navigation. The editor registers itself while it is mounted; a
 * tool that needs the surface and finds none reports that instead of failing silently.
 */
import type { SceneHandle } from '../ui/Scene3D';
import type { PlanHandle } from '../ui/PlanEditor';
import type { ScreenRect } from '../state/itemReveal';

export interface EditorAccess {
  scene3d(): SceneHandle | null;
  plan(): PlanHandle | null;
  /** The stage minus the panels over it — where the user can actually see. */
  visibleArea(): ScreenRect;
  fitPlan(): void;
}

export interface AppAccess {
  openProject(id: string, name: string): void;
  createProject(name: string): { id: string; name: string };
}

let editor: EditorAccess | null = null;
let app: AppAccess | null = null;

export function setEditorAccess(access: EditorAccess | null): void { editor = access; }
export function editorAccess(): EditorAccess | null { return editor; }
export function setAppAccess(access: AppAccess | null): void { app = access; }
export function appAccess(): AppAccess | null { return app; }
